/** Destino autenticado baseado no perfil carregado do banco. */
export function getDashboardPath(role: string | null | undefined): string | null {
  switch (role) {
    case "candidate": return "/candidato";
    case "company": return "/empresa";
    case "admin": return "/admin/blog";
    default: return null;
  }
}
